var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcStampInvoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 76C55.8823 76 72 59.8823 72 40C72 20.1178 55.8823 4 36 4C16.1178 4 0 20.1178 0 40C0 59.8823 16.1178 76 36 76Z",
    fill: "#0E5CF4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 71C59.33 71 75 55.33 75 36C75 16.67 59.33 1 40 1C20.67 1 5 16.67 5 36C5 55.33 20.67 71 40 71Z",
    fill: "white",
    stroke: "#00193C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 19H26V21H27V19ZM54 52V53C54.5523 53 55 52.5523 55 52H54ZM29 52H28C28 52.5523 28.4477 53 29 53V52ZM53 26.2V52H55V26.2H53ZM54 51H29V53H54V51ZM27 21H40.5V19H27V21ZM40.5 21H47.8V19H40.5V21ZM30 52V27.3125H28V52H30ZM55 26.2C55 22.2236 51.7764 19 47.8 19V21C50.6719 21 53 23.3281 53 26.2H55Z",
    fill: "#0E5CF4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29 27V28H30V27H29ZM23 27H22C22 27.5523 22.4477 28 23 28V27ZM28 23V27H30V23H28ZM29 26H23V28H29V26ZM24 27V23H22V27H24ZM26 21C27.1046 21 28 21.8954 28 23H30C30 20.7909 28.2091 19 26 19V21ZM26 19C23.7909 19 22 20.7909 22 23H24C24 21.8954 24.8954 21 26 21V19Z",
    fill: "#0E5CF4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34 33H48",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34 39H48",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45H48",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M34 27H40",
    stroke: "#0E5CF4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 27,
    r: 1.03333,
    fill: "#00193C",
    stroke: "#0E5CF4",
    strokeWidth: 1.93333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStampInvoice);
export default __webpack_public_path__ + "static/media/ic-stamp-invoice.bfc413af3bd156f5dd3eae7713f7d120.svg";
export { ForwardRef as ReactComponent };